import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Set of requests you can make to HAMS
 */

import * as hamsHttp from '@atlassian/commerce-hams-client';
export var getStripeKey = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fetch, url) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", hamsHttp.get(fetch, url));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getStripeKey(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var createSetupIntentClientSecret = function createSetupIntentClientSecret(fetch, url, input) {
  return hamsHttp.get(fetch, "".concat(url, "?gateway=").concat(input.gateway));
};